<crm-single-select
  [options]="rooms"
  [(selectedItem)]="selectedRoom"
  (selectedItemChange)="selectedRoomChange.emit($event)"
  [showClear]="showClear"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [appendTo]="appendTo"
  [disabled]="disabled"
  [loading]="loading">
</crm-single-select>
